module.exports = __webpack_public_path__ + "static/media/image10.262a6700.jpg";